import React from "react";
import './style.css';

const Option = (props) => {

    return (
      <div className="optionContainer">
        <img
          className="image "
          src={props.src}
          alt={props.alt}
          style={
            window.innerWidth > 600 ? { width: "50px" } : { width: "30px" }
          }
        />
        <h3>{props.optionName}</h3>
        <p>{props.optionDescription}</p>
      </div>
    );
}

export default Option;